<template>
  <!-- 
    <DictSelect
      :type="selectType" // 查询字典值的参数，后台提供，先在util/dictTypes.js文件中定义好，批量调用字典查询接口， 必填
      :multiple="multiple" // 是否多选，继承组件库
      :value="formValue" // v-model的值，继承组件库， 必填
      :excludes="excludes" // 特殊化，过滤掉特定的值
      :appendToBody="appendToBody" // 是否将弹出框插入至 body 元素, 继承组件库
      :propData="propData" // 自定义下拉值，不从接口中获取，传入数组
      :showAllOption="showAllOption" // 下拉值中是否显示全部的选项
      @change-emit="getValue" // 值改变后的回调，返回当前选中的值，继承组件库
    />
  -->
  <div class="cml-select-multiple">
    <el-popover
      width="250"
      v-model="popoverVisible"
      :disabled="!multiple || disabled"
      :placement="placement"
      trigger="click"
      @show="showPopover"
      class="cml-select-multiple-popover"
    >
      <div>
        <p style="margin: 0;color: #AB0033; border-bottom: 1px solid #ccc;">已选数据</p>
        <ul class="popoverBox">
          <li size="mini" v-for="(item, index) in selectData" :key="index">
            {{item.label}}
            <i class="el-icon-circle-close" @click="del(item.value)"></i>
          </li>
        </ul>
      </div>
      <el-button v-show="multiple" slot="reference" icon="el-icon-view" type="text"></el-button>
    </el-popover>
    <el-select
      ref="popoverSelect"
      slot="reference"
      v-model="selectValue"
      filterable
      :clearable="clearable"
      @change="change"
      @visible-change="visibleChange"
      :popper-append-to-body="appendToBody"
      :placeholder="placeholder"
      size="mini"
      :disabled="disabled"
      :multiple="multiple"
      :collapse-tags="multiple"
    >
      <el-option v-for="item in dictData" :key="item.id" :value="item.value" :label="item.label"></el-option>
    </el-select>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { remove, cloneDeep, filter } from 'lodash';
export default {
  props: {
    value: {
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    appendToBody: {
      default: true,
      type: Boolean
    },
    clearable: {
      default: true,
      type: Boolean
    },
    type: {
      type: String,
    },
    showAllOption: {
      default: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    excludes: {
      type: Array,
      default() {
        return [];
      }
    },
    propData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  watch: {
    value: {
      handler(val) {
        return (this.selectValue = val);
      }
    },
    propData: {
      deep: true,
      handler (arr) {
        this.dictData = arr;
        console.log(this.dictData, 111)
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['allDictListData'])
  },
  data: vm => ({
    dictData: [],
    selectData: [],
    selectValue: vm.value,
    popoverVisible: false,
    placement: 'right-start'
  }),
  beforeMount() {
    this.getDictData();
  },
  methods: {
    getDictData() {
      if (this.propData.length > 0) {
        this.dictData = this.propData;
      } else {
        this.excludesData();
      }
    },
    // 过滤传入的value值
    excludesData() {
      let cloneData = cloneDeep(this.allDictListData.data[this.type]);
      this.excludes.forEach(el => {
        remove(cloneData, n => {
          return el === n.value;
        });
      });
      this.dictData = cloneData;
    },
    change(val) {
      if (this.multiple) {
        this.setSelectData();
        this.popoverVisible = true;
      }
      this.$emit('change-emit', val);
    },
    visibleChange(visible) {
      if (this.selectData.length > 0) {
        this.placement = 'right-start';
        this.popoverVisible = visible;
      }
    },
    del(val) {
      this.selectValue = filter(this.selectValue, n => val !== n);
      this.setSelectData();
      this.$emit('change-emit', this.selectValue);
      if (this.selectValue.length < 1) this.popoverVisible = false;
    },
    // 阻止下拉框隐藏
    popoverClick() {
      if (this.selectValue.length > 0) this.$refs.popoverSelect.focus();
    },
    // 点击图标显示弹窗
    showPopover() {
      this.setSelectData();
    },
    // 设置seletdata
    setSelectData() {
      this.selectData = this.dictData.reduce((acc, cur) => {
        if (this.selectValue.includes(cur.value)) {
          acc = [
            ...acc,
            {
              label: cur.label,
              value: cur.value
            }
          ];
        }
        return acc;
      }, []);
    }
  }
};
</script>

<style lang="less" scoped>
@import '@/assets/styles/multiSelect.less';
</style>